import Modal from "react-modal";
import * as S from "./styles";
import Close from "assets/close-small.svg";
import { IMaintenance } from "interfaces/Maintenance";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  data: IMaintenance;
}

export function MoreMaintenanceDetailsModal({
  modalIsOpen,
  setIsOpen,
  data,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={S.CustomStyles}
      contentLabel="MoreMaintenanceDetails Modal"
    >
      <S.Container>
        <S.Header>
          <header>
            <h2>Dados da solicitação</h2>
            <img src={Close} alt="fechar" onClick={closeModal} />
          </header>
        </S.Header>
        <S.DataContainer>
          <S.Content>
            {data?.protocol && 
              <span>
                <label>Protocolo</label>
                <p>{data?.protocol}</p>
              </span>
            }
            <span>
              <label>Solicitante</label>
              <p>{data?.requester}</p>
            </span>
            {data?.manager && <span>
              <label>Gestor</label>
              <p>{data?.manager}</p>
            </span>}
            <span>
              <label>Cliente</label>
              <p>{data.client.name}</p>
            </span>
            {data.superficialClient && <span>
              <label>Sub Cliente</label>
              <p>{data.superficialClient.name}</p>
            </span>}
            <span>
              <label>Placa do veículo</label>
              <p>{data?.plate}</p>
            </span>
            <span>
              <label>Descrição ou observação</label>
              <p>{data?.description}</p>
            </span>
            <span>
              <label>Data de parada</label>
              <p>{new Date(data?.stopDate).toLocaleDateString('pt-BR')}</p>
            </span>
            <span>
              <label>Tipo de manutenção</label>
              <p>{data.type}</p>
            </span>
            <span>
              <label>Localização</label>
              <p>{data?.state +', '+ data.city}</p>
            </span>
            {data?.driver && <span>
              <label>Condutor</label>
              <p>{data?.driver}</p>
            </span>}
            <span>
              <label>Email ou telefone</label>
              <p>{data?.contact}</p>
            </span>
            <span>
              <label>Linha</label>
              <p>{data?.isHeavy? 'Pesada' : 'Leve'}</p>
            </span>
            {data?.vehicleBase && <span>
              <label>Base do veículo</label>
              <p>{data?.vehicleBase}</p>
            </span>}
            {data?.KM && <span>
              <label>Quilometragem</label>
              <p>{data?.KM}</p>
            </span>}

          </S.Content>
        </S.DataContainer>
      </S.Container>
    </Modal>
  );
}
